import rest from '../Utils/rest'

export const SA_createSignDoc = ({description, docName, imgSrc, type}) => {
    return rest.jsonPostUrl(`/api/sa/signDocs/create`, {description, docName, imgSrc, type})
}
export const SA_editSignDoc = ({description, docName, imgSrc, signDocId}) => {
    return rest.jsonPostUrl(`/api/sa/signDocs/${signDocId}/edit`, {description, docName, imgSrc})
}

export function SA_uploadSignDocZipFileAPI({files, onProgress, signDocId}) {
    return rest.uploadFiles(`api/sa/signDocs/${signDocId}/uploadZip`, files, onProgress)
}

export const SA_getAllCourses = ({paginationModel, filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/signDocs/all`, {paginationModel, filterModel})
}
export const SA_addSignDocToAllOrganizationsOfCompany = ({signDocId, companyId}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/addSignDocToAllOrganizationsOfCompany`, {signDocId, companyId})
}

export const SA_getAllOrganizationsForCompany = ({paginationModel, filterModel, companyId}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/allForCompany`, {paginationModel, filterModel, companyId})
}

export const SA_addSignDocToOrganization = ({signDocId, organizationId}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/addSignDoc`, {signDocId, organizationId})
}
export const SA_removeCourseFromOrganization = ({signDocId, organizationId}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/removeSignDoc`, {signDocId, organizationId})
}

export const SA_getAllCompanies = () => {
    return rest.getUrl(`/api/sa/companies/all`)
}

export const SA_getAllCompaniesPagination = ({paginationModel, filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/companies/all`, {paginationModel, filterModel})
}

export const SA_getSignDoc = ({signDocId}) => {
    return rest.getUrl(`/api/sa/signDocs/${signDocId}`)
}

export const SA_createCompany = ({
                                     companyName,
                                     companyUsersPrefix,
                                     countryCode,
                                     identifier,
                                     contactPhone,
                                     contactEmail,
                                     contactFirstName,
                                     contactLastName,
                                     userIdentifier,
                                     userPassword,
                                     userFirstName,
                                     userLastName
                                 }) => {
    return rest.jsonPostUrl(`/api/sa/companies/create`, {
        companyName,
        companyUsersPrefix,
        countryCode,
        identifier,
        contactPhone,
        contactEmail,
        contactFirstName,
        contactLastName,
        userIdentifier,
        userPassword,
        userFirstName,
        userLastName
    })
}

export const SA_getCompanyAndAdminUsers = ({companyId}) => {
    return rest.getUrl(`/api/sa/companies/${companyId}/companyAndAdminUsers`)
}


export const SA_updateCompany = ({
                                     companyName,
                                     identifier,
                                     countryCode,
                                     contactPhone,
                                     contactEmail,
                                     contactFirstName,
                                     contactLastName,
                                     companyId
                                 }) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/update`, {
        companyName,
        identifier,
        countryCode,
        contactPhone,
        contactEmail,
        contactFirstName,
        contactLastName
    })
}

/**
 * Updates isMfaRequired for all users in a company.
 * @param {object} params - The function parameters
 * @param {string} params.companyId - The company ID
 * @param {boolean} params.isMfaRequired - Whether MFA should be required
 * @returns {Promise<number>} Number of affected users
 */
export const SA_updateCompanyUsersMfaAPI = ({companyId, isMfaRequired}) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/updateUsersMfa`, {isMfaRequired})
}

export const SA_createOrganizationsForCompany = ({companyId, organizations}) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/createOrganizations`, {companyId, organizations})
}

export const SA_getAllUsersFiltered = ({paginationModel, filterModel, sortModel}) => {
    return rest.jsonPostUrl(`/api/sa/users/allFiltered`, {paginationModel, filterModel, sortModel})
}
export const SA_getAllOrganizationsFiltered = ({paginationModel, filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/allFiltered`, {paginationModel, filterModel})
}

export const SA_removeOrganizationAPI = ({organizationId}) => {
    return rest.jsonPostUrl(`/api/sa/organizations/${organizationId}/remove`, {})
}

export const SA_removeSignDocFromCompanyAPI = ({signDocId}) => {
    return rest.jsonPostUrl(`/api/sa/signDocs/${signDocId}/remove`)
}

/**
 * SuperAdmin: updates a user's profile fields and (optionally) organization membership.
 * When `organizationIds` is provided, the backend sets the user's membership to exactly that set
 * (diff + content sync), reusing the same admin membership helpers.
 * @param {object} params
 * @param {string} params.userId - Target user id.
 * @param {string} params.firstName - First name.
 * @param {string} params.lastName - Last name.
 * @param {string} params.email - Email.
 * @param {boolean} [params.isMfaRequired] - Whether MFA is required.
 * @param {string} [params.employeeId] - Employee id.
 * @param {string} [params.idNumber] - National id number.
 * @param {Array<string>} [params.organizationIds] - Desired full set of membership org IDs (omit to leave unchanged).
 * @returns {Promise<object>} Updated user.
 */
export const SA_updateUserAPI = ({userId, firstName, lastName, email, isMfaRequired, employeeId, idNumber, organizationIds}) => {
    return rest.jsonPostUrl(`/api/sa/users/${userId}/update`, {firstName, lastName, email, isMfaRequired, employeeId, idNumber, organizationIds})
}
export const SA_setCompanyQuotas = ({companyId, smsQuota, storageQuotaMB, userQuota}) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/setQuotas`, {smsQuota, storageQuotaMB, userQuota})
}

export const SA_getUsersData = ({userIds}) => {
    return rest.jsonPostUrl(`/api/sa/users/getData`, {userIds})
}
export const SA_deleteUsers = ({userIds}) => {
    return rest.jsonPostUrl(`/api/sa/users/remove`, {userIds})
}

/**
 * Permanently deletes multiple users from the database (bulk hard delete)
 * CRITICAL: This is a destructive operation that cannot be undone
 * @param {Object} params - The parameters object
 * @param {string[]} params.userIds - Array of user IDs to permanently delete
 * @returns {Promise<Object>} Result with deleted count
 */
export const SA_bulkPermanentlyDeleteUsers = ({userIds}) => {
    return rest.jsonPostUrl(`/api/sa/users/permanentlyDelete`, {userIds})
}

/**
 * Restores soft-deleted users in the system
 * Handles both single user and multiple users (bulk restore)
 * @param {Object} params - The parameters object
 * @param {string[]} params.userIds - Array of user IDs to restore (can be single or multiple)
 * @returns {Promise<Object>} Result with restored users count
 */
export const SA_restoreUsers = ({userIds}) => {
    return rest.jsonPostUrl(`/api/sa/users/restoreUsers`, {restoreUserIds: userIds})
}
export const SA_getCompanyFeatureFlags = ({companyId}) => {
    return rest.jsonPostUrl(`/api/sa/companies/getFeatureFlags`, {companyId})
}
export const SA_updateCompanyFeatureFlags = ({companyId, featureFlags}) => {
    return rest.jsonPostUrl(`/api/sa/companies/updateFeatureFlags`, {companyId, featureFlags})
}


export const SA_makeCompanyAdmin = ({newAdminUserId}) => {
    return rest.jsonPostUrl(`/api/sa/makeCompanyAdmin`, {newAdminUserId})
}

export const SA_makeRegularUser = ({adminUserId}) => {
    return rest.jsonPostUrl(`/api/sa/setAdminAsRegularUser`, {adminUserId})
}

export const SA_getAllSystemUsersAPI = ({startDate, endDate, granularity, includeDeleted, withoutGranularity}) => {
    return rest.jsonPostUrl(`/api/sa/getAllSystemUsers`, {
        startDate,
        endDate,
        granularity,
        includeDeleted,
        withoutGranularity
    })
}

export const SA_getAllSystemCompaniesAPI = ({startDate, endDate, granularity, includeDeleted, withoutGranularity}) => {
    return rest.jsonPostUrl(`/api/sa/getAllSystemCompanies`, {
        startDate,
        endDate,
        granularity,
        includeDeleted,
        withoutGranularity
    })
}

export const SA_getAllCompaniesWithStatsAPI = ({paginationModel, filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/getAllCompaniesWithStats`, {paginationModel, filterModel})
}


export const SA_createPartner = ({
                                     partnerName,
                                     identifier,
                                     contactPhone,
                                     contactEmail,
                                     contactFirstName,
                                     contactLastName
                                 }) => {
    return rest.jsonPostUrl(`/api/sa/partners/create`, {
        partnerName,
        identifier,
        contactPhone,
        contactEmail,
        contactFirstName,
        contactLastName
    })
}

export const SA_getAllPartnersPagination = ({paginationModel, filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/partners/all`, {paginationModel, filterModel})
}

/**
 * Checks if any partner has a client secret that is expiring or already expired
 * @returns {Promise<{hasExpiringClientSecret: boolean}>} True when at least one partner needs a new client secret
 */
export const SA_getPartnersClientSecretStatus = () => {
    return rest.getUrl(`/api/sa/partners/clientSecretStatus`)
}

export const SA_getPartnerAPIKey = ({partnerId}) => {
    return rest.jsonPostUrl(`/api/sa/partners/generateAPIKey`, {partnerId})
}
export const SA_getPartnerCreds = ({partnerId}) => {
    return rest.getUrl(`/api/sa/partners/${partnerId}/getNewCreds`)
}

export const SA_getCompaniesFiltered = ({filterModel}) => {
    return rest.jsonPostUrl(`/api/sa/companies/filtered`, {filterModel})
}

export const SA_setCompaniesForPartner = ({partnerId, companyIds}) => {
    return rest.jsonPostUrl(`/api/sa/partners/${partnerId}/setCompanies`, {companyIds})
}
export const SA_getCompaniesForPartner = ({partnerId}) => {
    return rest.getUrl(`/api/sa/partners/${partnerId}/companies`)
}

export const SA_sendCompanyWelcomeMessage = ({companyId, messageTypes}) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/sendWelcomeMessage`, {
        messageTypes
    }, {handleErrorByComponent: true})
}

/**
 * Get all company files for super admin with filtering and pagination
 * 
 * @param {Object} params - Parameters for the API call
 * @param {Object} params.paginationModel - Pagination parameters (page, pageSize)
 * @param {Object} params.filterModel - Filter parameters (filterValues)
 * @param {Object} params.sortModel - Sort parameters
 * @returns {Promise<Object>} - Promise that resolves to the API response
 */
export const SA_getCompanyFilesAPI = ({paginationModel, filterModel, sortModel}) => {
    return rest.jsonPostUrl(`/api/sa/companyFiles`, {paginationModel, filterModel, sortModel})
}

/**
 * Update a public asset's metadata
 * 
 * @param {Object} params - Parameters for the API call
 * @param {string} params.publicAssetId - The ID of the public asset to update
 * @param {string} [params.presentationName] - The display name of the file
 * @param {Array<string>} [params.tags] - Array of tags for the file
 * @param {string} [params.description] - Description of the file
 * @returns {Promise<Object>} - Promise that resolves to the updated public asset
 */
export const SA_updatePublicAssetAPI = ({publicAssetId, presentationName, tags, description}) => {
    console.log('SA_updatePublicAssetAPI - params:', { publicAssetId, presentationName, tags, description });
    return rest.jsonPostUrl(`/api/sa/publicAssets/${publicAssetId}/update`, {
        presentationName,
        tags,
        description
    })
}

/**
 * Update a company file's metadata
 * 
 * @param {Object} params - Parameters for the API call
 * @param {string} params.companyFileId - The ID of the company file to update
 * @param {string} [params.presentationName] - The display name of the file
 * @param {Array<string>} [params.tags] - Array of tags for the file
 * @param {string} [params.description] - Description of the file
 * @returns {Promise<Object>} - Promise that resolves to the updated company file
 */
export const SA_updateCompanyFileAPI = ({companyFileId, presentationName, tags, description}) => {
    console.log('SA_updateCompanyFileAPI - params:', { companyFileId, presentationName, tags, description });
    return rest.jsonPostUrl(`/api/sa/companyFiles/${companyFileId}/update`, {
        presentationName,
        tags,
        description
    })
}

/**
 * Generates a login URL for super admin to login as any user
 * Opens the user's dashboard in a new tab with automatic authentication
 * Token is single-use and expires after 2 hours
 *
 * @param {Object} params - Parameters for the API call
 * @param {string} params.targetUserId - The ID of the user to login as
 * @returns {Promise<Object>} Promise that resolves to { loginUrl: string }
 * @throws {Error} If user is not super admin or target user not found
 */
export const SA_loginAsUserAPI = ({targetUserId}) => {
    return rest.jsonPostUrl(`/api/sa/users/${targetUserId}/loginAs`, {targetUserId});
}

/**
 * Logs super admin logout from impersonation session
 * Records logout timestamp in token table and user's loginData for audit trail
 *
 * @param {Object} params - Parameters for the API call
 * @param {string} params.tokenId - UUID of the login token to mark as logged out
 * @param {string} params.targetUserId - ID of the user who was impersonated
 * @param {string} params.superAdminUserId - ID of the super admin logging out
 * @param {string} params.companyId - ID of the company
 * @returns {Promise<Object>} Promise that resolves to { success: boolean, loggedOutAt: string }
 * @throws {Error} If token or user not found
 */
export const SA_logoutAsUserAPI = ({tokenId, targetUserId, superAdminUserId, companyId}) => {
    return rest.jsonPostUrl(`/api/sa/users/logoutAs`, {tokenId, targetUserId, superAdminUserId, companyId});
}

/**
 * Downloads an Excel report with all companies and their statistics
 * @returns {Promise<Object>} Promise that resolves to an object containing fileId
 */
export const SA_downloadCompaniesReportAPI = () => {
    return rest.jsonPostUrl(`/api/sa/companies/downloadReport`, {})
}

/**
 * Manually triggers both recurring renewal cron jobs sequentially.
 * Runs SignDoc version creation first, then UserSignDoc transitions.
 * @returns {Promise<Object>} Result with success status and durationSeconds
 */
export const SA_runRecurringRenewalCronJobsAPI = () => {
    return rest.jsonPostUrl(`/api/sa/cronJobs/runRecurringRenewal`, {})
}

/**
 * Permanently deletes a company and all its data (SuperAdmin only).
 * The server backs up the company's UserSignDoc data to S3 before deleting.
 * @param {object} params - The function parameters
 * @param {string} params.companyId - The company to delete
 * @param {string} params.confirmationName - Must match the company name or identifier
 * @returns {Promise<object>} {success, dumpFile, deletedCounts, message}
 */
export const SA_deleteCompanyAPI = ({companyId, confirmationName}) => {
    return rest.jsonPostUrl(`/api/sa/companies/${companyId}/delete`, {confirmationName}, {handleErrorByComponent: true});
};

/**
 * SuperAdmin: checks if a phone is available within the target user's company.
 * `userId` is the target user (mapped to targetUserId for the backend).
 * @param {object} params
 * @param {string} params.userId - Target user id.
 * @param {string} params.phone - Phone in E.164 format.
 * @param {string} params.phoneCountryCode - ISO 2-letter country code.
 * @returns {Promise<{available: boolean, reason?: string}>}
 */
export const SA_checkPhoneAvailabilityAPI = ({userId, phone, phoneCountryCode}) => {
    return rest.jsonPostUrl(`/api/sa/users/checkPhoneAvailability`, {targetUserId: userId, phone, phoneCountryCode}, {handleErrorByComponent: true})
}

/**
 * SuperAdmin: updates a user's phone number (and derived identifier).
 * @param {object} params
 * @param {string} params.userId - Target user id.
 * @param {string} params.phone - Phone in E.164 format.
 * @param {string} params.phoneCountryCode - ISO 2-letter country code.
 * @returns {Promise<object>} Updated user.
 */
export const SA_updateUserPhoneAPI = ({userId, phone, phoneCountryCode}) => {
    return rest.jsonPostUrl(`/api/sa/users/${userId}/updatePhone`, {phone, phoneCountryCode}, {handleErrorByComponent: true})
}
